import React, {PropsWithChildren, useEffect} from "react";
import {useUserInfo} from "../hooks";
import {
    useBTCModalStore,
    useCEXBindModalStore,
    useEVMModalStore,
    useTONModalStore,
    useTRONModalStore,
    useWalletModalStore,
} from "../store/useModalStore";
import {BTCModal, TRONModal, TONModal, WalletModal, EVMModal} from "../components";
import CEXBindModal from "../components/CEXBindModal";
import {useQuery} from "@tanstack/react-query";
import {getTgAppLoginStatus} from "../api";
import {isSuccess} from "../api/request";
import useStore from "../store/useStore";
import {useMatch} from "../MatchContext";

export default function BusinessProvider({children}: PropsWithChildren) {
    const {overview, token} = useUserInfo()
    const {type: EVMType, isOpen: EVMIsOpen, close: EVMClose} = useEVMModalStore()
    const {type: TONType, isOpen: TONIsOpen, close: TONClose} = useTONModalStore()
    const {type: TRONType, isOpen: TRONIsOpen, close: TRONClose} = useTRONModalStore()
    const {type: BTCType, isOpen: BTCIsOpen, close: BTCClose} = useBTCModalStore()
    const {type: CEXType, isOpen: CEXIsOpen, close: CEXClose} = useCEXBindModalStore()
    const WalletModalStore = useWalletModalStore()
    const {tgAppAuthCode,setTgAppAuthCode} = useStore();
    const {login} = useMatch()

    const walletModalClose = (func:()=>void)=>{
        WalletModalStore.close()
        func()
    }

    useQuery({
        queryKey: ['matchid-tgapp-login',tgAppAuthCode],
        queryFn: async()=>{
            const res = await getTgAppLoginStatus({
                code:tgAppAuthCode
            })
            if(isSuccess(res)){
                setTgAppAuthCode('')
                await login({
                    // mid:'',
                    token: `${res.data.token_type} ${res.data.access_token}`
                })
                return true
            }
            return false
        },
        enabled: !!tgAppAuthCode,
        refetchInterval: 1000  * 5,
    })

    return (
        <>
            <EVMModal
                isOpen={EVMIsOpen && ((EVMType == 'login' && !overview && !token) || (EVMType == 'bind' && !!token && !!overview))}
                onClose={EVMClose} type={EVMType} onSuccess={()=>walletModalClose(EVMClose)} zIndex={199}/>
            <TRONModal
                isOpen={TRONIsOpen && ((TRONType == 'login' && !overview && !token) || (TRONType == 'bind' && !!token && !!overview))}
                onClose={TRONClose} type={TRONType} onSuccess={()=>walletModalClose(TRONClose)} zIndex={199}/>
            <TONModal
                isOpen={TONIsOpen && ((TONType == 'login' && !overview && !token) || (TONType == 'bind' && !!token && !!overview))}
                onClose={TONClose} type={TONType} onSuccess={()=>walletModalClose(TONClose)} zIndex={199}/>
            <BTCModal
                isOpen={BTCIsOpen && ((BTCType == 'login' && !overview && !token) || (BTCType == 'bind' && !!token && !!overview))}
                onClose={BTCClose} type={BTCType} onSuccess={()=>walletModalClose(BTCClose)} zIndex={199}/>
            <CEXBindModal isOpen={CEXIsOpen && (!!token && !!overview)}
                          onClose={CEXClose} type={CEXType} zIndex={199}/>
            <WalletModal
                isOpen={WalletModalStore.isOpen && ((WalletModalStore.type == 'login' && !overview && !token) || (WalletModalStore.type == 'bind' && !!token && !!overview))}
                onClose={WalletModalStore.close} type={WalletModalStore.type} methods={WalletModalStore.methods} zIndex={150}/>
            {children}
        </>
    );

}